module.exports = __webpack_public_path__ + "img/skrill.6dba3db8.svg";